import { UrlUtils } from '@atlassian/mpac-utils';

import VendorDetailsRouteHandler from './VendorDetailsRouteHandler';

export default ({ vendorDetailsConfig }) => [
  {
    name: 'vendorDetailsScreen',
    exact: true,
    path: UrlUtils.transformUriTemplateToRoutePath({
      template: vendorDetailsConfig.links.vendorDetailsPage.href,
    }),
    component: VendorDetailsRouteHandler,
  },
  {
    name: 'vendorDetailsScreen',
    exact: true,
    path: UrlUtils.transformUriTemplateToRoutePath({
      template: '/vendors/{vendorId}',
    }),
    component: VendorDetailsRouteHandler,
  },
];
